import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";

import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { AgGridReact } from "ag-grid-react";
import pdfMake from "pdfmake/build/pdfmake";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

const DeliveryChallanInwardTransactionList = forwardRef((porps, ref) => {
  const [StockPurchaselist, setStockPurchaselist] = useState([]);
  const gridRef = useRef();
  sessionStorage.setItem("tab", "PurchaseHistory");
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const code1 = location.state?.code;
  const data = useRef([]);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);
  console.log(id);
  useEffect(() => {
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 20 && item.view
  );

  useEffect(() => {
    getStockPurchaseList();
  }, []);

  const obj = { po_wo_inv_other_id: id, transaction_type_id: 8 };

  const getStockPurchaseList = () => {
    axios
      .post("/api/purple-fusion/stocktransaction/get", obj, headers)
      .then((response) => {
        if (response.data.length < 1) {
          document.getElementById("progress-bar-id").innerHTML =
            "No record found.";
        } else {
          setStockPurchaselist(response.data);
          console.log(response.data);
        }
        data.current = response.data.slice().sort((a, b) => b.id - a.id);
      })
      .catch((error) => {
        console.error("Error fetching stock transaction purchase data:", error);
      });
  };

  const sortedStockPurchaselist = StockPurchaselist.slice().sort(
    (a, b) => b.id - a.id
  );

  useImperativeHandle(
    ref,
    () => ({
      downloadExcel: () => {
        onBtnExport();
      },

      downloadPdf: () => {
        DownloadPDF();
      },
    }),
    []
  );

  const DownloadPDF = () => {
    const docDefinition = {
      pageOrientation: "portrait",
      header: {
        text: "Delivery Challan Inward List",
        style: "header",
      },
      content: [
        {
          style: "tableExample",
          table: {
            body: [
              [
                [{ text: "Sr.NO", style: "tableHeader", bold: true }],
                [{ text: "ITEM NAME", style: "tableHeader", bold: true }],
                [
                  {
                    text: "DELIVERY CHALLAN CODE",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: "QUANTITY", style: "tableHeader", bold: true }],

                [
                  {
                    text: "TRANSACTION TIME",
                    style: "tableHeader",
                    bold: true,
                  },
                ],
                [{ text: "DESCRIPTION", style: "tableHeader", bold: true }],
                [{ text: "CREATED DATE", style: "tableHeader", bold: true }],
              ],
              ...data.current?.map((item, index) => [
                index + 1,
                item.itemname,
                item.po_wo_inv_other_detail,
                item.quantity,
                item.transaction_date_time,
                item.description,
                item.createdon.substr(0, 10),
              ]),
            ],
            widths: "auto",
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex === 0 ? "#CCCCCC" : null;
            },
          },
        },
      ],
      styles: {
        tableExample: {
          fontSize: 10,
          color: "#333",
        },
        tableHeader: {
          bold: true,
          fontSize: 11,
          color: "#000",
        },
        header: {
          fontSize: 15,
          bold: true,
          margin: [10, 10, 20, 0],
          color: "#333",
        },
      },
    };
    pdfMake.createPdf(docDefinition).download("Delivery Challan Inward List");
  };

  const onBtnExport = useCallback(() => {
    const options = {
      fileName: "Purchase Inward List.csv",
    };

    gridRef.current.api.exportDataAsCsv(options);
  }, []);

  const [colDefs, setColDefs] = useState([
    { headerName: "Sr.No", field: "sr", width: 85 },
    {
      headerName: "ITEM NAME",
      field: "itemname",
      width: 120,
    },
    {
      headerName: "CODE",
      field: "code_op",
      width: 120,
    },
    {
      headerName: "TRANSACTION TYPE",
      field: "transactiontypename",
      width: 150,
    },
    {
      headerName: "DELIVERY CHALLAN CODE",
      field: "po_wo_inv_other_detail",
      width: 160,
    },
    { headerName: "QUANTITY", field: "quantity", width: 100 },
    {
      headerName: "TRANSACTION DATE",
      field: "transaction_date_time",
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
      width: 150,
    },
    {
      headerName: "TRANSACTION TIME",
      field: "transaction_date_time",

      valueFormatter: (params) => {
        const date = new Date(params.value);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const seconed = date.getSeconds();
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        const formattedTime =
          hours.toString().padStart(2, "0") +
          ":" +
          minutes.toString().padStart(2, "0") +
          ":" +
          seconed.toString().padStart(2, "0") +
          " " +
          ampm;
        return formattedTime;
      },
      width: 160,
    },
    {
      headerName: "DESCRIPTION",
      field: "description",
      valueFormatter: (params) => {
        return params.value ? params.value : "NA";
      },
      width: 120,
    },

    { headerName: "ACTIVE", field: "isactive", width: 100 },
    {
      headerName: "CREATED DATE",
      field: "createdon",
      valueFormatter: (params) => {
        return params.value.substr(0, 10);
      },
      minWidth: 80,
      maxWidth: 120,
    },
  ]);

  const ColDefaultVale = { filter: true };
  const gridOptions = {
    overlayNoRowsTemplate: `
          <div id="progress-bar-id" class="flex items-center justify-center">
              <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
          </div>
      `,
  };

  return (
    <>
      {showActionColumn ? (
        <div>
          <div
            className="ag-theme-quartz"
            // style={{ height: 550 ,width:"100%",fontSize:"12px" }}
            id="tab-grid-table"
          >
            <AgGridReact
              ref={gridRef}
              rowData={sortedStockPurchaselist.map((orders, index) => ({
                ...orders,
                sr: index + 1,
              }))}
              columnDefs={colDefs}
              pagination={true}
              defaultColDef={ColDefaultVale}
              suppressMenuHide={true}
              suppressExcelExport={true}
              gridOptions={gridOptions}
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </>
  );
});

export default DeliveryChallanInwardTransactionList;
